module.exports = __webpack_public_path__ + "static/media/call_stack.15046f76.png";